import { getQuizMaxHeight } from './getQuizMaxHeight';
export var getStepsProgress = function getStepsProgress(params) {
  var currentStep = params.currentStep,
      stepsHistory = params.stepsHistory,
      scheme = params.scheme;

  try {
    var quizMaxHeight = getQuizMaxHeight({
      currentStep: currentStep,
      scheme: scheme
    });
    /**
     * Кол-во пройденных шагов (currentStepCount) можно вычислить из истории шагов
     * Общая длина опросника (maxStepsCount) учитывыет прошедшие шаги и макс.возможное кол-во предстоящих шагов
     * */

    var currentStepCount = stepsHistory.length - 1;
    var maxStepsCount = currentStepCount + quizMaxHeight;
    return {
      currentStepCount: currentStepCount,
      maxStepsCount: maxStepsCount
    };
  } catch (e) {
    return {
      currentStepCount: 0,
      maxStepsCount: 0
    };
  }
};